<template>
    <Dropdown trigger="click" class="relative" :style="{float: 'right',fontWeight: 'normal'}" >
        <a href="javascript:void(0)" style="color:#515a73;">
            <Icon :type="icon || 'ios-arrow-down'" :size="iconSize || '12px;'"></Icon>
        </a>
        <DropdownMenu slot="list" class="overflow-auto">
            <vs-row class="mb-2 mt-2">
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center">
                    <i-input clearable search type="text" v-model="search" size="small"></i-input>
                </vs-col>
            </vs-row>
            <DropdownItem v-for="(item, key) in listData" :key="key" @click.native="onSelect(id, item.value)" :selected="item.value === selected">
                {{ item.label }}
            </DropdownItem>
            <vs-row class="mb-2 mt-2" v-if="!listData.length">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                    <span>Não Encontrado</span>
                </vs-col>
            </vs-row>
        </DropdownMenu>
    </Dropdown>
</template>

<script>
    export default {
        name: "dropdown-list",
        props: {
            id: [String, Number, Function],
            list: Array,
            onSelect: Function,
            icon: String,
            selected: Number,
            iconSize:Number
        },
        data:()=>({
            search:'',
        }),
        computed: {
            listData() {
                const search = this.search.toLowerCase()
                return this.list.filter(item=>{
                    if (search) {
                        return item.label.toLowerCase().includes(this.search)
                    }
                    return item
                })
            },
        },
    };
</script>